export type ApiErrorResponse = {
    messageId: "string"
    message: "string"
    error: "string"
}

export class ApiError extends Error {
    private readonly messageId: string

    constructor(error: ApiErrorResponse) {
        super(`${error.message}: ${error.error}`)

        this.messageId = error.messageId
    }

    throwIfIsNot(checkMessageId: string): void {
        if (this.messageId !== checkMessageId) {
            throw this
        }
    }

    throwIfIsNotOneOf(checkMessageIds: string[]): void {
        if (!checkMessageIds.includes(this.messageId)) {
            throw this
        }
    }
}
